import { render, staticRenderFns } from "./KitStatusChip.vue?vue&type=template&id=543c7c4a"
import script from "./KitStatusChip.vue?vue&type=script&lang=ts"
export * from "./KitStatusChip.vue?vue&type=script&lang=ts"
import style0 from "./KitStatusChip.vue?vue&type=style&index=0&id=543c7c4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports